import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faAddressBook,
  faArrowUp,
  faArrowUpRightFromSquare,
  faBars,
  faBook,
  faCalculator,
  faChartArea,
  faCheck,
  faCheckCircle,
  faCheckToSlot,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCirclePlus,
  faCircleNotch,
  faCog,
  faCopy,
  faComments,
  faDolly,
  faDownload,
  faEllipsisV,
  faExclamation,
  faExclamationCircle,
  faFileCirclePlus,
  faFileSignature,
  faFileImage,
  faFilter,
  faHeadset,
  faHome,
  faInfoCircle,
  faListAlt,
  faMinus,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPlus,
  faPowerOff,
  faPrint,
  faRotate,
  faSackDollar,
  faSearch,
  faShare,
  faSignInAlt,
  faSlidersH,
  faSquare,
  faSquareCheck,
  faStar,
  faStream,
  faTimes,
  faTrash,
  faTriangleExclamation,
  faUndo,
  faUser,
  faUserTie,
  faClone,
} from '@fortawesome/free-solid-svg-icons';

import {
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';

import {
  faSquare as faSquareRegular,
} from '@fortawesome/free-regular-svg-icons';

library.add(faClone);
library.add(faAddressBook);
library.add(faArrowUp);
library.add(faArrowUpRightFromSquare);
library.add(faBars);
library.add(faBook);
library.add(faCalculator);
library.add(faChartArea);
library.add(faCheck);
library.add(faCheckCircle);
library.add(faCheckToSlot);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faCircle);
library.add(faCirclePlus);
library.add(faCircleNotch);
library.add(faCog);
library.add(faCopy);
library.add(faComments);
library.add(faDolly);
library.add(faDownload);
library.add(faEllipsisV);
library.add(faExclamationCircle);
library.add(faFileSignature);
library.add(faFileCirclePlus);
library.add(faFileImage);
library.add(faFilter);
library.add(faHeadset);
library.add(faHome);
library.add(faInfoCircle);
library.add(faListAlt);
library.add(faMinus);
library.add(faPaperPlane);
library.add(faPaperclip);
library.add(faPen);
library.add(faPlus);
library.add(faPowerOff);
library.add(faPrint);
library.add(faRotate);
library.add(faSackDollar);
library.add(faSearch);
library.add(faShare);
library.add(faSignInAlt);
library.add(faSlidersH);
library.add(faSquare);
library.add(faSquareCheck);
library.add(faStar);
library.add(faStream);
library.add(faTimes);
library.add(faTrash);
library.add(faTriangleExclamation);
library.add(faUndo);
library.add(faUser);
library.add(faUserTie);
library.add(faExclamation);

library.add(faSquareRegular);

library.add(faWhatsapp);

Vue.component('font-awesome-icon', FontAwesomeIcon);
